import React from 'react';
import PropTypes from 'prop-types';

const ImageContainer = ({source, alt, customClasses, children}) => {
  return (
    <div className={customClasses}>
      <img
        src={source}
        alt={alt}
      />
      {children}
    </div>
  );
};

ImageContainer.propTypes = {
  source: PropTypes.string,
  alt: PropTypes.string,
  customClasses:  PropTypes.string,
  children: PropTypes.node
};

export default ImageContainer;
